import type { PersonalInfo } from "../types/personalInfo";

export const PERSONAL_INFO: PersonalInfo = {
  userName: "Marwan Ashraf",
  location: "Cairo, Egypt",
  availability: "Open to work",
  cvUrl: "https://drive.google.com/uc?export=download&id=14Js77f0Fr4nDZ_zggONeVhcntbDfmoYT",
};
